module.exports = __webpack_public_path__ + "media/images/default-avatar-b7eaa1679e520951c89b2251ab06607c.png";